export const APPS = [
  {
    slug: "cart-reservation-patrol",
    name: "Cart Reservation Patrol",
    tagline: "Real stock holds and cart timers to prevent overselling.",
    practice: "Ecommerce",
    status: "live",
    storeUrl: "https://apps.shopify.com/product-reservation-app",
    description:
      "Hold real inventory at add-to-cart—not a fake countdown. Stock stays reserved through checkout, then auto-releases when the timer expires. Built for drops, flash sales, and limited-stock SKUs.",
    features: [
      "Real inventory holds reserve stock at add-to-cart—not fake timers",
      "Cart countdown timers and banners create honest checkout urgency",
      "Auto-release expired holds; track reservations with AI insights",
      "Protect products for drops, flash sales, and limited-stock SKUs",
      "Reduce overselling and abandoned carts with checkout-ready holds",
    ],
    pricing: [
      { name: "Free", price: "Free", note: "Up to 3 products, 100 reservations / month" },
      { name: "Starter", price: "$17.50/mo", note: "Up to 25 products, 100 concurrent holds" },
      { name: "Growth", price: "$34/mo", note: "Unlimited products, analytics + AI insights" },
      { name: "Scale", price: "$92/mo", note: "Up to 1,000 concurrent holds for high-demand drops" },
    ],
  },
  {
    slug: "ai-sales-patrol",
    name: "AI Sales and Conversion Patrol",
    tagline: "AI that finds products, adds to cart, and starts checkout.",
    practice: "AI",
    status: "live",
    storeUrl: "https://apps.shopify.com/ai-sales-patrol",
    description:
      "An AI shopping assistant for your catalog. Natural conversations, personalized recommendations, and one-click paths to cart and checkout—so shoppers find the right product faster.",
    features: [
      "AI product recommendations from live catalog data",
      "Agent that can add to cart and send buyers to checkout",
      "Instant storefront Q&A for shoppers",
      "Conversational discovery that reduces buying friction",
      "Credit-based plans from Starter to Enterprise",
    ],
    pricing: [
      { name: "Starter", price: "$34/mo", note: "200 credits included" },
      { name: "Growth", price: "$93/mo", note: "800 credits included" },
      { name: "Professional", price: "$235/mo", note: "2,500 credits included" },
      { name: "Enterprise", price: "$585/mo", note: "8,000 credits included" },
    ],
  },
  {
    slug: "eu-compliance-patrol",
    name: "EU Compliance Patrol",
    tagline: "EU withdrawals, guarantees, GARAN labels & AI Act Art. 50 transparency.",
    practice: "Ecommerce",
    status: "live",
    storeUrl: "https://apps.shopify.com/eu-compliance-patrol",
    description:
      "Help Shopify merchants meet EU consumer and AI rules in one app. Capture right-of-withdrawal requests from the storefront, show legal guarantee notices and GARAN labels on products, and add AI transparency labels for Article 50 — with native theme, checkout, customer account, admin, and POS extensions.",
    features: [
      "Capture EU withdrawal requests on your storefront and manage them in Shopify",
      "Show EU legal guarantee notices and GARAN labels on product pages with one setup",
      "Admin GARAN edit, bulk & print plus checkout, thank-you and order-status blocks",
      "POS product and post-purchase blocks for consistent EU notices",
      "Label AI-generated product and Content file images for Article 50 disclosure",
      "Theme, checkout, customer account and POS extensions for unified compliance",
    ],
    pricingNote:
      "Prices match the Shopify App Store listing. Recurring and usage-based charges are billed every 30 days in USD. Withdrawals usage is billed separately at €0.05 per verified request.",
    pricingGroups: [
      {
        title: "Withdrawals",
        lead: "Pay-as-you-go withdrawals only. No monthly base fee for this module.",
        plans: [
          {
            name: "Withdrawals PAYG",
            price: "Free to install",
            badge: "Usage-based",
            note: "€0.05 per verified withdrawal. Storefront intake form, request tracking, email workflow support, and policy controls. Unverified spam is not billed.",
          },
        ],
      },
      {
        title: "Guarantees",
        lead: "Standalone legal guarantee notice and GARAN labels.",
        plans: [
          {
            name: "EU Guarantees",
            price: "$6/mo",
            note: "Admin GARAN edit, bulk & print; storefront guarantee & GARAN blocks; checkout, thank-you & order status; POS product & post-purchase blocks.",
          },
        ],
      },
      {
        title: "AI Labels",
        lead: "Standalone Art. 50 labeling for AI-generated or AI-modified media.",
        plans: [
          {
            name: "EU AI Labels",
            price: "$6/mo",
            note: "AI image labeling module, Article 50 transparency support, product and file image labels, admin controls & metafield sync.",
          },
        ],
      },
      {
        title: "Ultimate suite",
        lead: "All compliance modules in one subscription. Shopify allows one active app plan at a time.",
        plans: [
          {
            name: "EU Compliance Ultimate with AI",
            price: "€9.99/mo",
            badge: "Premium AI",
            note: "€9.99/month for all compliance modules plus Premium AI. Withdrawals and AI usage billed separately.",
          },
          {
            name: "All EU Compliances",
            price: "$11.50/mo",
            badge: "Bundle",
            note: "Includes Guarantees + AI Labels + withdrawal workflow. Unified compliance configuration across theme, admin, checkout & POS. Plus €0.05 per verified withdrawal.",
          },
        ],
      },
    ],
    pricing: [
      { name: "Withdrawals PAYG", price: "Free", note: "€0.05 per verified withdrawal" },
      { name: "EU AI Labels", price: "$6/mo", note: "Article 50 image labeling module" },
      { name: "EU Guarantees", price: "$6/mo", note: "Legal guarantees + GARAN labels" },
      {
        name: "EU Compliance Ultimate with AI",
        price: "€9.99/mo",
        note: "All compliance modules plus Premium AI. Withdrawals and AI usage billed separately.",
      },
      { name: "All EU Compliances", price: "$11.50/mo", note: "Full suite + €0.05 per verified withdrawal" },
    ],
  },
];

export function findApp(slug) {
  return APPS.find((app) => app.slug === slug);
}
